/* @flow */

export default {
  root: {
    width: 14,
    height: 11,
  },
};
